import { Nullable } from '../../types/utility';

export interface IBankService {
	fetchBanks(query: BanksQuery): Promise<BanksPage>;
}

export interface BanksQuery {
	country?: string;
	paginationSize?: number;
	paginationOffset?: number;
	searchTerm?: string;
}

export interface Bank {
	id?: number;
	name: string;
	country: BankCountry;
	bankCodes: Array<string>;
	bics: Array<string>;
	logo?: string;
	popularity: number;
}

export type BankCountry = 'AT' | 'DE';

export interface BanksPage {
	banks: Array<Bank>;
	pagination: PaginationMetadata;
}

export interface PaginationMetadata {
	count: number;
	total: number;
	offset: number;
	next?: Nullable<PaginationLink>;
	prev?: Nullable<PaginationLink>;
}

export interface PaginationLink {
	size: number;
	offset: number;
}

export type PaginationProperties = 'paginationSize' | 'paginationOffset';
export type PaginationOptions = Required<Pick<BanksQuery, PaginationProperties>>;

export const DEFAULT_PAGINATION_OPTIONS: PaginationOptions = {
	paginationSize: 10,
	paginationOffset: 0
};
